import {Fonts} from '../../../../shared/constants/AppEnums';
import styled from 'styled-components';

export const NavbarGroup = styled.ul`
  & .popper {
    z-index: 999;
  }

  & .popperClose {
    pointer-events: none;
  }

  & .pl0 {
    padding-left: 0;
  }

  & .font-bold {
    font-family: ${Fonts.MEDIUM};
  }

  & .ml2 {
    margin-left: 8px;
  }

  & .text-lg {
    font-size: 18px;
  }
`;
